import React, { useRef } from 'react';
import styled from '@emotion/styled'

import { Button, TextField, IconButton } from '@mui/material';

// Add Icon
import AddIcon from '@mui/icons-material/Add';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';

// hooks
import useRequestItems from '../../../hooks/useRequestItems';

import { BasicFlex } from '../../../utils/Common';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import { detectEnter } from '../../../utils/util';

const Container = styled.div`
  margin-bottom: 2.5rem;
`;

const AddCodeBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: .6rem 1rem;
  background-color: ${props => props.theme.colors.lightBg};

  @media ${props => props.theme.breaks.down("md")} {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: .3rem;
    padding: .3rem 0;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  gap: 1rem;

  button {
    min-width: 13rem;
  }
`;

const Label = styled.div`
  font-weight: 600;
  background-color: white;
  padding: .2rem .6rem;
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 3px;
`;

const WigLine = styled(BasicFlex)`
  padding: .2rem 1rem;
  border-bottom: 1px solid ${props => props.theme.colors.border};
  background-color: ${props => props.theme.colors.lightBg};
`;

const WigInfo = styled(BasicFlex)`
  gap: 3rem;
`;

const WigTitle = styled.div`
  font-weight: 600;
`;

const WigDescription = styled.div`
  
`;

const WigActions = styled.div`
  
`;

const ShipmentItems = ({ inventoryItem }) => {
  const { formValues, addWigCode, removeItem } = useRequestItems();
  const codeRef = useRef(null);
  const addWig = () => {
    let value = codeRef.current.value?.toUpperCase();
    addWigCode({ wig_id: value, ...inventoryItem });
    codeRef.current.value = '';
    codeRef.current.focus();
  }
  let wigs = formValues?.wigs?.filter(el => el.sku === inventoryItem?.sku) || [];
  return (
    <Container>
      <AddCodeBar>
        <Label>{wigs.length} Items</Label>
        <Actions>
          <TextField id="outlined-basic" onKeyDown={(e) => detectEnter(e, addWig)} inputRef={codeRef} placeholder='Enter Code' size="small" variant="outlined" slotProps={{ input: { style: { backgroundColor: '#fff' } } }} />
          <Button variant="contained" color="secondary" startIcon={<AddIcon />} onClick={addWig}>Add Code</Button>
        </Actions>
      </AddCodeBar>

     {wigs?.map((el, i) => <WigLine key={el.wig_id}>
        <WigInfo justify="flex-start">
          <WigTitle>{el.wig_id}</WigTitle>
          {/* <SimpleChip label={el.sku} uc /> */}
        </WigInfo>
        <WigActions>
          <IconButton size="small" onClick={() => removeItem(el.wig_id, 'wigs', 'wig_id')}><RemoveCircleOutlineRoundedIcon color="error" /></IconButton>
        </WigActions>
      </WigLine>
      )}

    </Container>
  )
};

export default ShipmentItems;